// External modules
import React from 'react';
import { isEmpty, cloneDeep } from 'lodash';

// Internal modules
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import Modal from '@material-ui/core/Modal';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import ACUIElement from '../../atoms/ACUIElement';
import ACButton from '../../atoms/ACButton';
import PreviewClue from '../../../medias/clue-info-screen.png';
import ACSelect from '../../atoms/ACSelect';

import styles from './SetClue.module.scss';
import { getUIElementType, getUIElement, getMediaForUIName } from '../../common/global';

// TODO: Move this into global and merge with provider's clue types
const clueTypes = [
  { key: 'alphabet-code', value: 'Alphabet Code' },
  { key: 'anagram', value: 'Anagram' },
  { key: 'anagram-meets-trivia', value: 'Anagram Meets Trivia' },
  { key: 'code-craker', value: 'Code Cracker' },
  { key: 'collection-challange', value: 'Collection Challenge' },
  { key: 'crossword', value: 'Crossword' },
  { key: 'hangman', value: 'Hangman' },
  { key: 'identifying-patterns-images', value: 'Identifying Patterns / Images' },
  { key: 'look-for-this-sign-icon', value: 'Look for this Sign / Icon' },
  { key: 'menu-trivia', value: 'Menu Trivia' },
  { key: 'rebus', value: 'Rebus' },
  { key: 'rebus-2', value: 'Rebus 2.0' },
  { key: 'riddle', value: 'Riddle' },
  { key: 'spelling-errors', value: 'Spelling Errors' },
  { key: 'telephone-code', value: 'Telephone Code' },
  { key: 'trivia-word-reveal', value: 'Trivia Word Reveal' },
  { key: 'word-search', value: 'Wordsearch' },
];

export default class SetClue extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSamplePreviewOpen: false,
    };
  }

  onUploadACUIElementMedia = (name, s3FolderName, mediaType, file) => {
    const mediaFor = { ui: getMediaForUIName().clue, name: name, s3FolderName: s3FolderName };
    this.props.uploadMediaFunc(mediaFor, mediaType, file);
  };

  closeSamplePreview = () => {
    this.setState({ isSamplePreviewOpen: false });
  };

  openSamplePreview = () => {
    this.setState({ isSamplePreviewOpen: true });
  };

  onChangeClueText = (e) => {
    if (isEmpty(e) || isEmpty(e.target)) return null;
    const { name = '', value = '' } = e.target;

    this.props.onChangeClueFunc(name, value);
  };

  onChangeClueType = (name, clueType) => {
    if (isEmpty(clueType)) return null;
    const { value = '' } = clueType;
    this.props.onChangeClueFunc(name, value);
  };

  onChangeACUIElement = (uiElement) => {
    const { clue = {}, onChangeClueFunc } = this.props;
    const { uiElements = [] } = clue;
    const { type = '', subType = '' } = uiElement;

    const index = uiElements.findIndex((ele) => {
      if (!isEmpty(subType)) return ele.type === type && ele.subType === subType;
      else return ele.type === type;
    });
    if (index >= 0) uiElements[index] = uiElement;
    else uiElements.push(uiElement);
    onChangeClueFunc('uiElements', uiElements);
  };

  renderUIElements() {
    const mediaFor = 'challenge';
    const { clue = {}, spark } = this.props;

    const { uiElements = [] } = clue;

    const clueHard = getUIElement(uiElements, getUIElementType().clueHard);
    const hint = getUIElement(uiElements, getUIElementType().hint);
    return (
      <React.Fragment>
        <div className={styles.section}>
          <div className={styles.sectionHeading}>Clue Hard</div>
          <ACUIElement
            name="clueHard"
            mediaFor={mediaFor}
            mediaName="clueClueHard"
            uiElement={clueHard}
            onChangeACUIElementFunc={this.onChangeACUIElement}
            onUploadACUIElementMediaFunc={this.onUploadACUIElementMedia}
            showSolvable
            spark={spark}
          />
        </div>
        <div className={styles.section}>
          <div className={styles.sectionHeading}>Hint</div>
          <ACUIElement
            name="hint"
            mediaFor={mediaFor}
            mediaName="clueHint"
            uiElement={hint}
            showHeading={false}
            showSubheading={false}
            onChangeACUIElementFunc={this.onChangeACUIElement}
            onUploadACUIElementMediaFunc={this.onUploadACUIElementMedia}
          />
        </div>
      </React.Fragment>
    );
  }

  renderClueTypes() {
    const { clue = {} } = this.props;
    const { type = '' } = clue;
    const clueType = clueTypes.find((cT) => {
      return cT.key === type;
    });

    if (isEmpty(clueTypes)) return <div />;

    return (
      <div className={styles.selectContainer}>
        <span className={styles.adornment}>Clue Type</span>
        <ACSelect
          name="type"
          showLabel={false}
          options={clueTypes}
          option={clueType}
          optionLabel={'value'}
          optionValue={'key'}
          onChangeFunc={this.onChangeClueType}
        />
      </div>
    );
  }

  renderPreviewExample() {
    const { isSamplePreviewOpen = false } = cloneDeep(this.state);
    return (
      <div>
        <Dialog open={isSamplePreviewOpen} aria-labelledby="draggable-dialog-title">
          <DialogContent>
            <img
              alt="media"
              src={PreviewClue}
              style={{
                display: 'flex',
                margin: 'auto',
                color: 'white',
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.closeSamplePreview}
              color="primary"
              fullWidth="true"
              variant="contained"
              style={{
                color: 'white',
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  render() {
    const { clue = {}, isModalOpen = false, onCloseFunc, onSaveClueFunc } = this.props;

    return (
      <div>
        {this.renderPreviewExample()}
        <Modal open={isModalOpen} onClose={onCloseFunc}>
          <div className={styles.root}>
            <div>
              <div className={styles.fullWidthColumn}>
                <div className={styles.top}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <h3>Set Clue</h3>
                    <div className={styles.previewIcon} onClick={this.openSamplePreview}>
                      i
                    </div>
                  </div>
                  <div>
                    <CloseIcon className={styles.pointerCursor} onClick={onCloseFunc} />
                  </div>
                </div>
                <div className={styles.middle}>
                  <div>
                    <span className={styles.title}>Details</span>
                    <div
                      style={{
                        marginTop: '20px',
                      }}
                    >
                      <TextField
                        name="name"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start" className={styles.adornment}>
                              Name
                            </InputAdornment>
                          ),
                        }}
                        className={styles.textField}
                        value={clue.name}
                        onChange={this.onChangeClueText}
                        placeholder="Clue Name"
                      />
                    </div>
                    {this.renderClueTypes()}
                  </div>
                  {this.renderUIElements()}
                </div>
                <div className={styles.bottom}>
                  <ACButton
                    text={'Save'}
                    icon={<SaveIcon />}
                    iconLast={true}
                    onClickFunc={onSaveClueFunc}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
